'use strict';
import angular from 'angular';
import _ from 'lodash';

angular.module('widget.geochart.ctrls', [])

    .controller('GeoChartWidgetController', GeoChartWidgetController);

GeoChartWidgetController.$inject = [
    '$scope',
    'DrawOption',
    'ChartPlotType',
    'MapTypes',
    'TapMapConfig'
];
function GeoChartWidgetController(
    $scope,
    DrawOption,
    WidgetType,
    MapTypes,
    TapMapConfig,
    ChartFactory,
) {
    $scope.$on('chart:setMetadataDefaults', function(e, metadata) {
        setMetadataDefaults(metadata);
    });

    function setMetadataDefaults(metadata) {
        var drawOptions = {};
        drawOptions[DrawOption.HAS_TOOLTIP] = true;

        const isLegacy = metadata.dynamic.hasOwnProperty('raw_data') && !metadata.draw_options.plot_type;
        drawOptions[DrawOption.PLOT_TYPE] = metadata.draw_options[DrawOption.PLOT_TYPE] || ChartFactory.getDefaultPlotType(WidgetType.GEOCHART, isLegacy);

        drawOptions[DrawOption.MAP_TYPE] = metadata.draw_options[DrawOption.MAP_TYPE] || MapTypes.STREET;
        drawOptions[DrawOption.TAP_MAP_CONFIG] = metadata.draw_options[DrawOption.TAP_MAP_CONFIG] || TapMapConfig.BOUNDARY;
        metadata.draw_options = _.assign(drawOptions, metadata.draw_options);
    }
}